import { defineSlotRecipe } from '@chakra-ui/react';

export const priceSlotRecipe = defineSlotRecipe({
    slots: ['discountBadge', 'priceValueWrapper', 'discountPrice', 'mainPrice', 'formattedPrice'],
    base: {
        discountBadge: {
            colorPalette: 'brand',
            px: 2,
            py: 1,
            rounded: 'md',
            mb: 1,
        },
        priceValueWrapper: {
            flexDir: 'column',
            gap: 0,
            alignItems: 'flex-end',
        },
        discountPrice: {
            fontSize: 'xs',
        },
        mainPrice: {
            fontSize: {
                base: 'lg',
                md: '2xl',
            },
            lineHeight: '1',
        },
        formattedPrice: {
            fontWeight: 'normal',
            fontSize: {
                base: 'sm',
                md: 'lg',
            },
            color: 'gray.900',
            display: 'inline-block',
            verticalAlign: 'middle',
            mb: 1,
            ml: 2,
        },
    },
    variants: {
        variant: {
            accommodationTile: {
                discountBadge: {
                    h: 5,
                    rounded: 'sm',
                },
                priceValueWrapper: {
                    flexDir: {
                        base: 'row',
                        md: 'column',
                    },
                    gap: {
                        base: 2,
                        md: 0,
                    },
                },
                discountPrice: {
                    color: 'gray.500',
                    fontSize: 'sm',
                    lineHeight: '1.2',
                },
            },
        },
    },
});
